import { useState, useEffect } from "react";
import ApiClient from "../services/api-client"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const getInitials = (name) => {
    if (!name) return '?';
    const words = name.trim().split(/\s+/);
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
};

const MetaRow = ({ icon, value, mono }) => {
    if (!value) return null;
    return (
        <div className="co-meta-item">
            <i className={`fa ${icon} co-meta-icon`}></i>
            <span className={mono ? "co-meta-val co-meta-mono" : "co-meta-val"}>{value}</span>
        </div>
    );
};

export default function CompanySearch() {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        ApiClient.getUserCompanies().then(
            response => {
                setCompanies(response.data || []);
                setLoading(false);
            },
            () => setLoading(false)
        );
    }, []);

    return (
        <div className="template-search-container container">

            <div className="co-search-topbar">
                <div className="template-search-header co-search-header-inline">
                    <div className="template-search-header-icon">
                        <i className="fa fa-building"></i>
                    </div>
                    <div>
                        <h4 className="template-search-title mb-0">{t('userCompanies')}</h4>
                        {companies.length > 0 && (
                            <p className="template-search-subtitle mb-0">{companies.length} {t('companies')}</p>
                        )}
                    </div>
                </div>
                <button className="btn btn-skin co-add-btn" onClick={() => navigate("/usercompany")}>
                    <i className="fa fa-plus"></i>
                    <span>{t("companyAdd")}</span>
                </button>
            </div>

            {loading ? (
                <div className="template-search-empty">
                    <i className="fa fa-spinner fa-spin fa-2x" style={{ color: 'var(--appcolor)', opacity: 0.5 }}></i>
                </div>
            ) : companies.length === 0 ? (
                <div className="template-search-empty">
                    <i className="fa fa-building fa-3x"></i>
                    <p>{t("noResults")}</p>
                </div>
            ) : (
                <div className="row g-4">
                    {companies.map(company => (
                        <div className="col-md-6" key={company.id}>
                            <div className="co-card" onClick={() => navigate("/usercompany/" + company.id)}>

                                {/* ── SEAL HEADER ── */}
                                <div className="co-card-seal-header">
                                    <div className="co-seal-ring">
                                        <div className="co-seal-circle">
                                            <span className="co-seal-initials">{getInitials(company.name)}</span>
                                        </div>
                                    </div>
                                    <div className="co-card-company-name">{company.name}</div>
                                    {company.taxOffice?.name && (
                                        <div className="co-card-taxoffice">{company.taxOffice.name}</div>
                                    )}
                                </div>

                                {/* ── META INFO ── */}
                                <div className="co-card-meta">
                                    <MetaRow icon="fa-id-card-o" value={company.taxpayerId} mono />
                                    <MetaRow icon="fa-certificate" value={company.gemh ? `${t("GEMH")}: ${company.gemh}` : null} mono />
                                    <MetaRow icon="fa-envelope-o" value={company.accountantEmail} />
                                    <MetaRow icon="fa-cloud-upload" value={company.myDATAProvider} />
                                </div>

                                {/* ── BRANCHES ── */}
                                {company.branches?.length > 0 && (
                                    <div className="co-card-branches">
                                        <div className="co-branches-label">
                                            <i className="fa fa-map-marker"></i>
                                            {t("Branches")}
                                            <span className="co-branches-count">{company.branches.length}</span>
                                        </div>
                                        {company.branches.map((b, i) => (
                                            <div className="co-branch-row" key={i}>
                                                <span className="co-branch-num">{b.branchNumber ?? i}</span>
                                                <div className="co-branch-info">
                                                    {b.name && <span className="co-branch-name">{b.name}</span>}
                                                    {b.address && <span className="co-branch-address"><i className="fa fa-map-pin"></i> {b.address}</span>}
                                                    {b.subjectField && <span className="co-branch-subject">{b.subjectField}</span>}
                                                    {b.phone && <span className="co-branch-address"><i className="fa fa-phone"></i> {b.phone}</span>}
                                                    {b.email && <span className="co-branch-address"><i className="fa fa-envelope-o"></i> {b.email}</span>}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* ── FOOTER ── */}
                                <div className="co-card-footer-bar">
                                    <i className="fa fa-pencil"></i>
                                    <span>{t("Edit")}</span>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
